var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Bits Extension Setup Guide")]),_c('p',[_vm._v(" WIP, check back for updates. ")])])
}]

export { render, staticRenderFns }